import { StylesheetRenderer } from './stylesheet.renderer';
import { AdSlotContainerView } from '../../containers/ad-slot-container.view';
import { EventTypeEnum } from '../../dto/recs.dto';
import { AdSlotContainer } from '../../entities/ad-slot-container';
import { RendererInterface } from '../../interfaces/components/renderer/renderer.interface';
import { Injectable } from '../dependency-injection/decorators';
import { AdSlotContainerLifecycleEvent } from '../event-manager/event/ad-slot-container-lifecycle.event';
import { AdSlotContainerPreRenderEvent } from '../event-manager/event/ad-slot-container-pre-render.event';
import { BackendEvent } from '../event-manager/event/backend.event';
import { Events } from '../event-manager/event/events';
import { EventManager } from '../event-manager/event-manager';

@Injectable()
export class AdSlotContainerRenderer implements RendererInterface {
  public constructor (
    private readonly eventManager: EventManager,
    private readonly adSlotContainerView: AdSlotContainerView,
    private readonly stylesheetRenderer: StylesheetRenderer,
  ) {
  }

  public async render (adSlotContainer?: AdSlotContainer): Promise<void> {
    if (!adSlotContainer || adSlotContainer.isRendered()) {
      return;
    }

    const adSlot = adSlotContainer.getAdSlot();

    if (!adSlot) {
      return;
    }

    const event = await this.eventManager.dispatch(
      Events.AD_SLOT_CONTAINER_PRE_RENDER,
      new AdSlotContainerPreRenderEvent(adSlotContainer),
    );

    if (event.isPropagationStopped()) {
      return;
    }

    if (adSlotContainer.getItems().length === 0) {
      await this.eventManager.dispatch(
        Events.BACKEND_EVENT,
        new BackendEvent(adSlot.getId(), EventTypeEnum.AD_SLOT_NO_ITEMS),
      );
    }

    const element = adSlotContainer.getElement();

    if (!element || adSlotContainer.getItems().length === 0) {
      // track event even if no items are rendered
      await this.eventManager.dispatch(
        Events.AD_SLOT_CONTAINER_POST_RENDER,
        new AdSlotContainerLifecycleEvent(adSlotContainer),
      );
      return;
    }

    element.className = this.stylesheetRenderer.getClass(adSlot, 'outerContainer');
    element.appendChild(await this.adSlotContainerView.render(adSlotContainer));

    adSlotContainer.setIsRendered(true);

    await this.eventManager.dispatch(
      Events.AD_SLOT_CONTAINER_POST_RENDER,
      new AdSlotContainerLifecycleEvent(adSlotContainer),
    );
  }
}
